<template>
  <div class="analytics-page">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Analytics
    </hero-bar>
    <section class="section is-main-section reporting-analytics-section">
      <h2>Reporting Analytics</h2>
      <div class="columns">
        <div class="column ">
          <report-per-country-stream></report-per-country-stream>
        </div>
      </div>
      <div class="columns">
        <div class="column "><total-count-report></total-count-report></div>
      </div>
    </section>
    <section class="section is-main-section kpi-analytics-section">
      <!-- <h2>KPIs</h2>
      <div class="columns">
        <div class="column">
          <ontime-vslate></ontime-vslate>
        </div>
        <div class="column">
          <resubmitted-report></resubmitted-report>
        </div>
      </div> -->
      <div class="columns">
        <div class="column">
          <days-before-deadline-report></days-before-deadline-report>
        </div>
      </div>
      <!-- <div class="columns">
        <div class="column">
          <correct-and-revised-reports
            :account-id="Number(userId)"
          ></correct-and-revised-reports>
        </div>
      </div> -->
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import OntimeVslate from "@/components/Analytics/OntimeVsLate";
import ResubmittedReport from "@/components/Analytics/ResubmittedReports";
import TotalCountReport from "@/components/Analytics/TotalCountReport";
// import ReportByCountryStream from "@/components/Analytics/ReportByCountryStream";
import ReportPerCountryStream from "@/components/Analytics/ReportPerCountryStream";
import CorrectAndRevisedReports from "@/components/Analytics/CorrectAndRevisedReports";
import DaysBeforeDeadlineReport from "@/components/Analytics/DaysBeforeDeadlineReport";

export default {
  name: "AnalyticsView",
  components: {
    HeroBar,
    TitleBar,
    // OntimeVslate,
    // ResubmittedReport,
    TotalCountReport,
    // ReportByCountryStream,
    ReportPerCountryStream,
    DaysBeforeDeadlineReport
    // CorrectAndRevisedReports
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "switchCustomerView"
    ]),
    titleStack() {
      return [{ url: "/analytics", name: "Analytics" }];
    }
  }
};
</script>
